import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { ValueAdapter } from '../value.adapter';
import { Owned } from 'app/model/base/named';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toCursorMethodObject(pArray: ParameterConfig[] | undefined): any {
    if (pArray != null && pArray.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result: any = {};
        pArray.forEach((v) => {
            if (ValueAdapter.toResource(v, ParameterConfig.VALUE) !== '') {
                result[v.name] = ValueAdapter.toResource(v, ParameterConfig.VALUE);
            }
            if (result[v.name] != null && (v.name === 'skip' || v.name === 'limit') && !result[v.name].type) {
                if (!isNaN(parseInt(result[v.name], 10))) {
                    result[v.name] = parseInt(result[v.name], 10);
                } else {
                    delete result[v.name];
                }
            }
        });
        return result;
    } else {
        return undefined;
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toCursorMethodClass(pObject: any, owner?: Owned): ParameterConfig[] | undefined {
    if (pObject != null) {
        const result: ParameterConfig[] = [];
        let paramConfig;
        for (const propertyName in pObject) {
            if (owner != null) {
                paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, owner);
                paramConfig.name = propertyName;
                ValueAdapter.toModel(paramConfig, ParameterConfig.VALUE, pObject[propertyName]);
            } else {
                paramConfig = new ParameterConfig();
                paramConfig.name = propertyName;
                paramConfig.value = pObject[propertyName];
            }
            result.push(paramConfig);
        }
        return result;
    } else {
        return [];
    }
}
